import { useListPayoutRequests } from "@fp/admin-api-client/payout-requests/payout-requests.client";
import { useListPayables } from "@fp/admin-api-client/payouts/payouts.client";
import { PayoutRequestStatus } from "@fp/admin-api-client";
import { Button } from "@fp/ui/components/base/buttons/button";
import { Link, useRouterState } from "@tanstack/react-router";
import {
	BarChart01,
	Briefcase01,
	CurrencyDollarCircle,
	Home05,
	User01,
} from "@untitledui/icons";

export default function MobileNav() {
	const { data: requestsData } = useListPayoutRequests({
		page: 1,
		pageSize: 1,
		statuses: [PayoutRequestStatus.Pending],
		latestPerClaim: true,
	});

	const { data: payoutsData } = useListPayables({
		page: 1,
		pageSize: 1,
		overdue: true,
	});

	const reviewCount = requestsData?.data.totalCount ?? 0;
	const overdueCount = payoutsData?.data.totalCount ?? 0;
	const needsAttentionCount = reviewCount + overdueCount;

	// The Pay section spans several route prefixes (payout requests, payouts, and
	// the opportunity-claim payout timeline), so match them all for the active tab.
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});
	const isPayActive =
		pathname.startsWith("/payout-requests") ||
		pathname.startsWith("/payouts") ||
		pathname.startsWith("/opportunity-claims");

	return (
		<div className="flex flex-row items-center justify-around px-1 py-4 gap-1 h-16 z-10 shadow-[0_-6px_6px_-6px_rgba(0,0,0,0.2)]">
			<Link
				to="/dashboard"
				activeProps={{ className: "*:text-fieldpay-blue-600" }}
				className="rounded-xl w-full flex items-center justify-center"
			>
				<Button className="p-3 size-full hover:bg-gray-50" color="tertiary">
					<div className="flex flex-col items-center">
						<Home05 className="size-5" />
						<span className="text-xs">Home</span>
					</div>
				</Button>
			</Link>
			<Link
				to="/opps"
				activeProps={{ className: "*:text-fieldpay-blue-600" }}
				className="rounded-xl w-full flex items-center justify-center"
			>
				<Button className="p-3 size-full hover:bg-gray-50" color="tertiary">
					<div className="flex flex-col items-center">
						<Briefcase01 className="size-5" />
						<span className="text-xs">Opps</span>
					</div>
				</Button>
			</Link>
			<Link
				to="/payout-requests"
				className={`rounded-xl w-full flex items-center justify-center ${isPayActive ? "*:text-fieldpay-blue-600" : ""}`}
			>
				<Button className="p-3 size-full hover:bg-gray-50" color="tertiary">
					<div className="flex flex-col items-center">
						<div className="relative">
							<CurrencyDollarCircle className="size-5" />
							{needsAttentionCount > 0 && (
								<span className="absolute -top-2 -right-3 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1">
									{needsAttentionCount}
								</span>
							)}
						</div>
						<span className="text-xs">Pay</span>
					</div>
				</Button>
			</Link>
			<Link
				to="/roster"
				activeProps={{ className: "*:text-fieldpay-blue-600" }}
				className="rounded-xl w-full flex items-center justify-center"
			>
				<Button className="p-3 size-full hover:bg-gray-50" color="tertiary">
					<div className="flex flex-col items-center">
						<User01 className="size-5" />
						<span className="text-xs">Roster</span>
					</div>
				</Button>
			</Link>
			<Link
				to="/reporting"
				activeProps={{ className: "*:text-fieldpay-blue-600" }}
				className="rounded-xl w-full flex items-center justify-center"
			>
				<Button className="p-3 size-full hover:bg-gray-50" color="tertiary">
					<div className="flex flex-col items-center">
						<BarChart01 className="size-5" />
						<span className="text-xs">Reporting</span>
					</div>
				</Button>
			</Link>
		</div>
	);
}
